import InputStatus from './dom';
export default InputStatus;
